import imagen from "../../images/Mobile-SW.png";
import "./Bienvenida.css";

export const Bienvenida = () => {
  return (
    <div id="bienvenida">
      <div className="bienvenida-container">
        <div className="bienvenida-box">
          <h1 style={{ fontWeight: "600" }}>Bienvenida Ellie Care</h1>
          <h1 style={{ fontWeight: "500", marginTop: "-10px" }}>
            a América Latina.
          </h1>
          <br />
          <h1 style={{ fontWeight: "600" }}>Bienvenida América Latina</h1>
          <h1 style={{ fontWeight: "500", marginTop: "-10px" }}>
            a la evolución del bienestar de los +65 años.
          </h1>
        </div>
        <div className="bienvenida-box-image" style={{ display: "flex" }}>
          <img
            className="bienvenida-image"
            src={imagen}
            alt="Illustration of a family"
          />
        </div>
      </div>
    </div>
  );
};

export default Bienvenida;
